import { VictoryChart, VictoryGroup, VictoryVoronoiContainer } from 'victory';

import lang from '../../../lib/language';

import { useIsMobile } from '../../../hooks';
import {
  CHART_CONTAINER_PADDING,
  CHART_CONTAINER_PADDING_TOP_RIGHT,
  CHART_CONTAINER_WIDTH,
  MYACCOUNT_CHART_HEIGHT_MOB,
  MYACCOUNT_CHART_HEIGHT_WEB,
  VORONOI_CONTAINER_HEIGHT_WEB,
  VORONOI_CONTAINER_WIDTH,
} from '../constants';

import CustomTooltip from './ChartComponents/CustomTooltip';

type Props = {
    data: any;
    children: any;
    showPerformance: boolean;
    setShowPerformance: (value: boolean) => void;
    setChartValue: (value: number) => void;
    setCurrentDate: (value: string) => void;
}

const ChartWrapper = (props: Props) => {
  const { children, data, showPerformance, setShowPerformance, setChartValue, setCurrentDate } = props;
  const { isMobile } = useIsMobile();

  return (
    <>
      {isMobile ? (
        <VictoryGroup
          width={CHART_CONTAINER_WIDTH}
          height={MYACCOUNT_CHART_HEIGHT_MOB}
          padding={{ ...!isMobile ? CHART_CONTAINER_PADDING : {}, top: 70 }}
          maxDomain={{ x: data.lineData.length < data.aMonth ? data.aMonth - 1 : data.lineData.length - 1 }}
          minDomain={{ x: 0, y: 0 }}
          events={[{
            childName: 'all',
            target: 'parent',
            eventHandlers: {
              onMouseLeave: () => ({
                mutation: () => {
                  setShowPerformance(true);
                },
              }),
            },
          }]}
          containerComponent={(
            <VictoryVoronoiContainer
              labels={({ datum }) => `${Math.round(datum.x)}, ${Math.round(datum.y)}`}
              onActivated={(d) => {
                setShowPerformance(false);
                setChartValue(d.length ? d[0].value : 0);
                setCurrentDate(d.length ? d[0].date : lang.performanceRangeTextToday());
              }}
              labelComponent={(
                <CustomTooltip fillColor={'#3BB0FF'} showPerformance={showPerformance} />
                  )}
            />
              )}
        >
          {children}
        </VictoryGroup>
      ) : (
        <VictoryChart
          width={CHART_CONTAINER_WIDTH}
          height={MYACCOUNT_CHART_HEIGHT_WEB}
          padding={{ ...!isMobile ? CHART_CONTAINER_PADDING_TOP_RIGHT : {}, top: 30 }}
          maxDomain={{ x: data.lineData.length < data.aMonth ? data.aMonth : data.lineData.length }}
          minDomain={{ x: 0, y: 0 }}
          events={[{
            childName: 'all',
            target: 'parent',
            eventHandlers: {
              onMouseLeave: () => ({
                mutation: () => {
                  setShowPerformance(true);
                },
              }),
            },
          }]}
          containerComponent={(
            <VictoryVoronoiContainer
              width={VORONOI_CONTAINER_WIDTH}
              height={VORONOI_CONTAINER_HEIGHT_WEB}
              labels={({ datum }) => `${Math.round(datum.x)}, ${Math.round(datum.y)}`}
              onActivated={(d) => {
                setShowPerformance(false);
                setChartValue(d.length ? d[0].value : 0);
                setCurrentDate(d.length ? d[0].date : lang.performanceRangeTextToday());
              }}
              labelComponent={(
                <CustomTooltip fillColor={'#3BB0FF'} showPerformance={showPerformance} />
                    )}
            />
                )}
        >
          {children}
        </VictoryChart>
      )}
    </>
  );
};

export default ChartWrapper;
